import { useMutation } from '@apollo/react-hooks';
import { gql } from 'graphql-tag';
import { logDevError } from 'shared/alerts';

export const DUPLICATE_ANNUAL = gql`
  mutation DuplicateAnnual($input: Int!) {
    duplicateAnnual(annual_id: $input) {
      id
      series {
        id
        name
      }
      tracks {
        id
        name
      }
      account {
        id
        business_dba
      }
      ticket {
        id
        name
        sale_end
      }
      name
      status
      events {
        id
        name
      }
    }
  }
`;

export function useDuplicateAnnual() {
  const [duplicateAnnualMutation] = useMutation(DUPLICATE_ANNUAL);
  const duplicateAnnual = async (id) => {
    try {
      const response = await duplicateAnnualMutation({
        variables: { input: id },
      });
      return response;
    } catch (error) {
      logDevError(error);
    }
  };

  return duplicateAnnual;
}
